import { Country } from '@afterpaytouch/portal-api/types'
import { useCountry, useGetCreditCheckConsent } from '../../state'

export const useHasDurableFebConsent = (): boolean => {
  const country = useCountry()
  const creditCheckConsent = useGetCreditCheckConsent()
  return country === Country.US && creditCheckConsent === true
}
